export default __webpack_public_path__ + "static/lifeplugin-8d8b8a7ec40f00009e636b57a99538cf.png";